import {useCallback, useEffect, useRef} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {setUpdateSWStatus} from '@/actions/updateSystemAction';
import {getProgressUpdateSW} from '@/api/updateApi';
import {changeSystemUpdateProgress} from '@/businesses/systemUpdateBusiness';
import {UpdateStateEnum, UpdateSWStatusType} from '@/constants/dataEnum';

const INTERVAL = 1000;

const useSystemUpdateProgress = () => {
  const updateSWStatus = useSelector((state) => state.updateSystemStore.updateSWStatus);
  const dispatch = useDispatch();
  const intervalRef = useRef();

  const clear = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = null;
  }, []);

  const register = useCallback(() => {
    clear();
    intervalRef.current = setInterval(async () => {
      const response = await getProgressUpdateSW();

      dispatch(changeSystemUpdateProgress(response.data.Message));

      if (response.data.Status === UpdateStateEnum.COMPLETE) {
        dispatch(setUpdateSWStatus(UpdateSWStatusType.COMPLETE));
        clear();
      }
      else if (response.data.Status === UpdateStateEnum.FAILED) {
        dispatch(setUpdateSWStatus(UpdateSWStatusType.FAILED));
        clear();
      }
    }, INTERVAL);
  }, [clear, dispatch]);

  useEffect(() => {
    if (updateSWStatus === UpdateSWStatusType.IN_PROGRESS) register();
    else clear();

    return () => {
      clear();
    };
  }, [clear, updateSWStatus, register]);

  return null;
};
export default useSystemUpdateProgress;
